import { cloneDeep } from 'lodash';
import DESCRIPTION from '../../config/descriptions.json';

export default function getDescriptionForCurrentGame(parametersSource, gameSlug = null) {
    let slug;
    if (gameSlug != null && !parametersSource?.slug) {
        slug = gameSlug;
    } else {
        slug = parametersSource?.slug;
    }
    return cloneDeep(DESCRIPTION[slug]) ?? [];
}
